import { create } from 'zustand';
import * as announcementService from '../api/announcementService';
import logger from '../utils/logger';

// ponytail: Zustand store replacing the AnnouncementContext boilerplate
export const useAnnouncementStore = create((set, get) => ({
  announcements: [],
  loading: false,
  error: null,
  initialized: false,

  fetchAnnouncements: async (params = {}) => {
    try {
      set({ loading: true });
      const response = await announcementService.getAllAnnouncements(params);
      set({ announcements: response.data.announcements || [], error: null, initialized: true });
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        set({ announcements: [], error: null, initialized: true });
        return;
      }
      logger.error('Error fetching announcements:', err);
      set({ error: err.response?.data?.message || 'Failed to load announcements' });
    } finally {
      set({ loading: false });
    }
  },

  addAnnouncement: async (formData) => {
    try {
      const response = await announcementService.createAnnouncement(formData);
      set((state) => ({ announcements: [response.data.announcement, ...state.announcements] }));
      return { success: true, data: response.data.announcement };
    } catch (err) {
      logger.error('Error adding announcement:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to create announcement' };
    }
  },

  updateAnnouncement: async (id, data) => {
    try {
      const response = await announcementService.updateAnnouncement(id, data);
      set((state) => ({
        announcements: state.announcements.map((item) => (item._id === id ? response.data.announcement : item)),
      }));
      return { success: true, data: response.data.announcement };
    } catch (err) {
      logger.error('Error updating announcement:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to update announcement' };
    }
  },

  deleteAnnouncement: async (id) => {
    try {
      await announcementService.deleteAnnouncement(id);
      set((state) => ({ announcements: state.announcements.filter((item) => item._id !== id) }));
      return { success: true };
    } catch (err) {
      logger.error('Error deleting announcement:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to delete announcement' };
    }
  },

  toggleAnnouncementStatus: async (id) => {
    try {
      const response = await announcementService.toggleAnnouncementStatus(id);
      set((state) => ({
        announcements: state.announcements.map((item) => (item._id === id ? response.data.announcement : item)),
      }));
      return { success: true, data: response.data.announcement };
    } catch (err) {
      logger.error('Error toggling announcement status:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to toggle status' };
    }
  },

  bulkDelete: async (ids) => {
    try {
      await announcementService.bulkDeleteAnnouncements(ids);
      set((state) => ({ announcements: state.announcements.filter((item) => !ids.includes(item._id)) }));
      return { success: true };
    } catch (err) {
      logger.error('Error bulk deleting announcements:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to delete announcements' };
    }
  },
}));
